<template>
    <!-- Keep number of grid items consistent with LayoutCardsSwiper -->
    <div class="layout-cards grid grid-cols-1 gap-2.5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'LayoutCards',
};
</script>
